// src/ramda-adjunct/isNotEmpty.ts
import isEmpty from "ramda/src/isEmpty";
function isNotEmpty(val) {
  return !isEmpty(val);
}
var isNotEmpty_default = isNotEmpty;

export {
  isNotEmpty_default
};
//# sourceMappingURL=chunk-UUVQ4RET.mjs.map